/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-22 19:20:25
 *
 *******************************************************/
// @flow

import _ from 'lodash';

class StockStatusHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption, initialValue) => {
    const { manualValues } = filterOption;
    const inStock = _.find(manualValues, { key: 'in-stock' });
    const outOfStock = _.find(manualValues, { key: 'out-of-stock' });

    const stockStatusInStock = inStock ? true : false;
    const stockStatusInStockLabel = inStock ? inStock.label : '';
    const stockStatusOutOfStock = outOfStock ? true : false;
    const stockStatusOutOfStockLabel = outOfStock ? outOfStock.label : '';

    const result = {
      ...initialValue,
      stockStatusManualValues: [],
      stockStatusInStock,
      stockStatusInStockLabel,
      stockStatusOutOfStock,
      stockStatusOutOfStockLabel
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption, defaultValues) => {
    let manualValues = [];
    const {
      stockStatusInStock,
      stockStatusInStockLabel,
      stockStatusOutOfStock,
      stockStatusOutOfStockLabel
    } = filterOption;

    // Save stock status in manual values
    if (stockStatusInStock) {
      manualValues.push({ key: 'in-stock', label: stockStatusInStockLabel });
    } else {
    }

    if (stockStatusOutOfStock) {
      manualValues.push({ key: 'out-of-stock', label: stockStatusOutOfStockLabel });
    }

    const result = {
      ...defaultValues,
      manualValues,
      displayType: 'list'
    };

    return result;
  };

  /**
   * Fake product data for stock status
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = filterOption => {
    const values = [];
    const { manualValues } = filterOption;

    if (!_.isArray(manualValues)) return values;

    manualValues.forEach(manualValue => {
      values.push(_.assign(manualValue, { doc_count: Math.floor(Math.random() * 100) + 1 }));
    });

    return values;
  };
}

export default StockStatusHelper;
